import * as React from 'react';
import { Grid, makeStyles, Theme, useTheme } from '@material-ui/core';

export interface SimpleLayoutProps {}

const useClasses = makeStyles((theme: Theme) => ({
  root: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
  },
}));

const SimpleLayout: React.FC<SimpleLayoutProps> = (props) => {
  const theme = useTheme();
  const classes = useClasses(theme);
  return (
    <Grid container justifyContent={'center'} direction={'row'} className={classes.root}>
      <Grid item xs={11} sm={11} md={11} lg={10} xl={9}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default SimpleLayout;
